<router-outlet></router-outlet>
<app-popup *ngIf="popupService.isPopupVisible()"></app-popup>
